import manifestHandlers from '../initialParams/initialParamsService';
import log from '../logger/log';
import getManifestTemplate from './manifestTemplate';

const setupManifest = () => {
    try {
        attachGeneratedManifest();

        manifestHandlers.handleInitialParameters();
    } catch (e) {
        log.error('manifestService: Failed to setup manifest', e);
    }
};

const attachGeneratedManifest = () => {
    const manifestTemplate = getManifestTemplate();
    const manifestBlob = new Blob([JSON.stringify(manifestTemplate)], {type: 'application/json'});
    const manifestURL = URL.createObjectURL(manifestBlob);

    document.querySelector('#manifest')?.setAttribute('href', manifestURL);
};

export default {
    setupManifest,
};
